export default [
  {
    title: 'Fitur Pendukung',
    customicon: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0037 9.82C13.1937 9.82 14.1637 8.85 14.1637 7.66C14.1637 6.47 13.1937 5.5 12.0037 5.5C10.8137 5.5 9.84375 6.47 9.84375 7.66C9.84375 8.85 10.8137 9.82 12.0037 9.82Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.79281 19.5C7.98281 19.5 8.95281 18.53 8.95281 17.34C8.95281 16.15 7.98281 15.18 6.79281 15.18C5.60281 15.18 4.63281 16.15 4.63281 17.34C4.63281 18.53 5.59281 19.5 6.79281 19.5Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.2069 19.5C18.3969 19.5 19.3669 18.53 19.3669 17.34C19.3669 16.15 18.3969 15.18 17.2069 15.18C16.0169 15.18 15.0469 16.15 15.0469 17.34C15.0469 18.53 16.0169 19.5 17.2069 19.5Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
    resource: 'Fitur Pendukung',
    route: 'opsional-feature',
    action: 'manage',
  },
]
